import React from 'react';
import IndexPage from '../index-table/IndexPage';

export default class SparePartsFinderIndexPage extends IndexPage {

    constructor(props) {
        super(props);
        this.state = {
            columns: this.props.columns,
            filter: this.props.filter,
            results: this.props.results,
            paging: this.props.paging
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.market !== this.props.market) {
            this.onFilterChange('Market', newProps.market);
        }
    }

    getFilterModel = filters => {
        let filter = {};
        filters.forEach(x => filter = {...filter, [_.camelCase(x.meta.slug)]: x.model});
        return filter;
    }

    buildFilterRequestModel() {
        return this.getFilterModel(this.state.filter.viewFilters);
    }

    onFiltersChange = filters => {
        var request = this.buildIndexAPIRequestModel();
        var newFilters = _.union(this.state.filter.viewFilters, filters, 'meta.slug');
        request.filter = this.getFilterModel(newFilters);
        this.postIndexData(request);
    }

    mergeFilterWithFilterDataFilter(response) {
        return {};
    }

    createStateForPostIndexData(response) {
        return {
            ...super.createStateForPostIndexData(response),
            columns: response.data.columns,
            filter: response.data.filters,
            priceSummary: response.data.priceSummary
        }
    }

    onFilterChange = (slug, value) => {
        const filters = this.state.filter.viewFilters.map(x => x.meta.slug === slug ? {
            ...x,
            model: value
        } : x);
        this.onFiltersChange(filters);
    }

    renderHeader = () => <React.Fragment/>
}